import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'

import { Tab } from './components/Tab'
import { TabList } from './components/TabList'
import {
  TabContextType,
  TabModeEnum,
  TabsProviderProps,
  TabType,
} from './interface'

export const TabContext = React.createContext<TabContextType>({
  activeTab: '',
  mode: TabModeEnum.BOX,
  handleUpdateActiveTab: (key: string) => {},
  handleTabNameChange: (tabId: string, tabName: string) => {},
})

export const Tabs = ({
  initialTabs = [],
  children,
  className,
  borderBottomClassName,
  id,
  mode = TabModeEnum.BOX,
  onActiveTabChange,
  isFirstTabMargin = false,
}: TabsProviderProps) => {
  const router = useRouter()
  const [tabs, setTabs] = useState<TabType[]>(initialTabs)
  const [activeTab, setActiveTab] = useState<string>('')

  function handleUpdateActiveTab(key: string) {
    if (activeTab === key) return

    setActiveTab(key)
    if (onActiveTabChange) {
      onActiveTabChange(key)
    }
  }

  function handleTabNameChange(tabId: string, tabName: string) {
    const index = tabs.findIndex(row => row.tabId === tabId)

    if (index !== -1) {
      const tmp = [...tabs]
      tmp[index].name = tabName

      setTabs(tmp)
    }
  }

  useEffect(() => {
    setActiveTab((router.query.tab as string) || initialTabs[0].tabId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.tab])

  const value = {
    activeTab,
    mode,
    handleUpdateActiveTab,
    handleTabNameChange,
  }

  return (
    <TabContext.Provider value={value}>
      <div className='relative'>
        <TabList
          id={id}
          className={className}
          borderBottomClassName={borderBottomClassName}
          isFirstTabMargin={isFirstTabMargin}
        >
          {tabs.map((row, i) => (
            <Tab key={row.tabId} tabId={row.tabId} dataTest={row.dataTest}>
              {row.name}
            </Tab>
          ))}
        </TabList>
      </div>
      {children}
    </TabContext.Provider>
  )
}

export function useTab() {
  return useContext(TabContext)
}
